import { useCallback } from "react";

import type { RoomInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";
import { RoomList_ListPage_Query } from "@/components/features/items/list/room/_hooks/use-room-list/query";

import { RoomCreateMutation } from "./mutation";
import { RoomNewItem_EditPage_Query } from "../query/query";

export const useCreateRoomMutation = () => {
	const { mutationFunc } = useCustomMutation(RoomCreateMutation);
	const onCreateRoom = useCallback(
		async (
			input: RoomInput, //
		) =>
			await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: RoomList_ListPage_Query,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: RoomNewItem_EditPage_Query,
						variables: {
							hotelID: input.hotelID,
						},
						fetchPolicy: "network-only",
					},
					{
						query: START_GUIDE_QUERY,
						variables: { hotelID: input.hotelID },
					},
				],
			}),
		[mutationFunc],
	);

	return { onCreateRoom };
};
